// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2YL7C","buttons":"SendReceipts_buttons__ndNNw","email":"SendReceipts_email__z6KEu","bookApptTitle":"SendReceipts_bookApptTitle__1_HQM"};